import { Injectable, NgZone } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MobileDetectorService {

  public static DESKTOP_MIN_WIDTH = 992;

  private isInitialized = false;
  private isMobile$: BehaviorSubject<boolean> = new BehaviorSubject(true);

  constructor(private zone: NgZone) {}

  public init(): void {
    if (this.isInitialized) return;

    this.isInitialized = true;
    this.zone.runOutsideAngular(() => {
      window.addEventListener('resize', this.onResize.bind(this));
      dispatchEvent(new Event('resize'));
    });
  }

  get isMobile(): Observable<boolean> {
    return this.isMobile$.asObservable();
  }

  private onResize(event: any): void {
    this.zone.run(() => {
      if (event?.target?.innerWidth === event?.target?.innerHeight) {
        this.zone.runOutsideAngular(() => {
          setTimeout(() => this.detectMobileSize(event?.target?.innerWidth), 0);
        });
      } else {
        this.detectMobileSize(event?.target?.innerWidth);
      }
    })
  }

  private detectMobileSize(screenWidth: number): void {
    this.isMobile$.next(screenWidth < MobileDetectorService.DESKTOP_MIN_WIDTH);
  }
}
